import { render, staticRenderFns } from "./template-manage-page.html?vue&type=template&id=742aff83&"
import script from "./template-manage-page.ts?vue&type=script&lang=ts&"
export * from "./template-manage-page.ts?vue&type=script&lang=ts&"
import style0 from "./template-manage-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports